<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
                            <router-link class="btn GeneralLeave-back btnBack" to="/anticipos">
							    <font-awesome-icon icon="fa-solid fa-circle-chevron-left" /> Atrás
							</router-link>
                        </div>
						<div class="title">
							<h3>Anticipos</h3>
						</div>
					</div>
                    <div class="itemList-header">
                        <!-- <h1>Ver {{ anticipo }}</h1> -->
                        <h1>Ver</h1>
                    </div>
                    <div id="Detail" class="detail-Generalleave">
                        <div class="row">
                            <div class="col-md-4 col-sm-4 col-xs-12">
                                <label for="">Titulo</label>
                                <p>{{ anticipo.titulo }}</p>
                            </div>
                            <div class="col-md-4 col-sm-4 col-xs-12">
                                <label for="">Importe</label>
                                <p>{{ anticipo.importe.replace('.',',') }} €</p>
                            </div> 
                            <div class="col-md-4 col-sm-4 col-xs-12">
                                <label for="">Devolución</label>
                                <p>{{ anticipo.devolucion }}</p>
                            </div>
                        </div>
                        
                        <hr />
                        
                        <div class="row">
                            <div class="col-md-12 col-sm-12 col-xs-12">
                                <label for="">Observaciones</label>
                                <p>{{ anticipo.observaciones }}</p>
                            </div>
                        </div>
                        
                        <hr />
                        
						<div class="form-group">
                            
                            <label for="">Tramites:</label> 
                            <ul class="listaTramites" v-for="(anticipoTramite, index) in anticipoTramites">
                                <li>
                                    <!--<strong>
                                       <u>Tramite {{ vacacionesTramite.length - index }}</u>: {{ formatDate(vacacionesTramite.fecha) }} / {{ vacacionesTramite.usuario }} / {{ vacacionesTramite.estado }}
                                    </strong>-->
                                    <strong>
                                        <u>Tramite {{ anticipoTramites.length - index }}</u>: {{ formatDate(anticipoTramite.fecha) }} / {{ anticipoTramite.estado }}
                                     </strong>
                                </li>
                                <div>
                                    <i>
                                        {{ anticipoTramite.observacionesRRHH }}
                                    </i>
                                    <i>
                                        {{ anticipoTramite.observacionesResponsable }}
                                    </i>
                                </div>
                            </ul>
                            
                        </div>
                    </div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import Encabezado from "@/components/Encabezado.vue";
    import Footer from "@/components/Footer.vue";

    export default {
        name: "DetalleAnticipo",
		components: {
            Encabezado,
            Footer,
        },
		data() { 
			return{}
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
		},
		computed:{
            anticipos: function(){
				let anticipos = this.$store.state.perfil.anticipos || [];
			
                return (Array.isArray(anticipos))? anticipos : [anticipos];
			},
			anticipo: function(){
                let anticipo = null;

				if (this.anticipos.length > 0){
                    anticipo = this.anticipos.find(anticipo=>{
                        return anticipo.id == this.$route.params.id_anticipo;
                    });
				}

                return anticipo;
			},
			anticipoTramites:function(){
                let anticipoTramites = this.anticipo.tramites || [];
                
                console.log(anticipoTramites);

                return (Array.isArray(anticipoTramites))? anticipoTramites : [anticipoTramites];
            }
		},
        methods:{
            formatDate: function (date) {
				return this.moment(date).format('DD/MM/YYYY');
			}  
        }
    };
</script>

<style>
    @import "../assets/styles/home.css";
</style>
